import React from 'react';
import { Link } from 'react-router-dom';

const pillars = [
  {
    title: 'Identity',
    description: 'Not the SKU — the individual unit. Serial number, revision, batch, firmware, compatible parts. Two products that look identical may differ in twelve ways that matter when something goes wrong. BrandedMark knows the difference.',
    href: '/product/product-identity',
    icon: '🔗',
    stat: 'Know exactly which product',
  },
  {
    title: 'Support',
    description: 'Generic chatbots hallucinate spare parts and quote wrong warranties. BrandedMark\'s AI is grounded in product truth — which exact unit, which owner, which warranty state, which service history. The customer scans. The system answers. No phone call, no ticket, no app download.',
    href: '/product/post-purchase-experience',
    icon: '🛡️',
    stat: 'AI that knows the product',
  },
  {
    title: 'Operations',
    description: 'Digital warranty activation at unboxing. Claims intake with serial verification. Repair routing to certified technicians. Returns processing with eligibility checks. Ownership transfer at resale. Replace email, spreadsheets, and phone queues with one workflow.',
    href: '/product/post-purchase-experience',
    icon: '⚙️',
    stat: 'Warranty, returns, and service — orchestrated',
  },
];

export const ProductPillars: React.FC = () => {
  return (
    <div className="bg-gray-50 py-24 sm:py-32" id="product-pillars">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center mb-16">
          <h2 className="text-base/7 font-semibold" style={{ color: '#00D084' }}>
            One platform, three pillars
          </h2>
          <p className="mt-2 text-3xl font-semibold tracking-tight sm:text-4xl" style={{ color: '#241E61' }}>
            Everything your product needs after the sale
          </p>
          <p className="mt-4 text-lg text-gray-600">
            Identity, support, and operations — unified in one system.
          </p>
        </div>

        <div className="mx-auto grid max-w-2xl grid-cols-1 gap-8 lg:max-w-none lg:grid-cols-2">
          {pillars.map((pillar) => (
            <Link
              key={pillar.title}
              to={pillar.href}
              className="group relative rounded-2xl border border-gray-200 bg-white p-8 shadow-sm transition-all duration-200 hover:shadow-md hover:border-gray-300"
            >
              <div className="flex items-start gap-4">
                <span className="text-3xl">{pillar.icon}</span>
                <div className="flex-1">
                  <h3 className="text-xl font-semibold text-gray-900 group-hover:text-purple-700 transition-colors">
                    {pillar.title}
                    <span className="inline-block ml-2 text-sm opacity-0 group-hover:opacity-100 transition-opacity" aria-hidden="true">&rarr;</span>
                  </h3>
                  <p className="mt-2 text-sm text-gray-600 leading-relaxed">
                    {pillar.description}
                  </p>
                  <p className="mt-3 text-xs font-semibold uppercase tracking-wide" style={{ color: '#00D084' }}>
                    {pillar.stat}
                  </p>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-12 flex justify-center gap-4">
          <p className="text-sm text-gray-500 italic max-w-lg text-center">
            EU Digital Product Passport compliance included. GS1 Digital Link format, ESPR-ready structure, jurisdiction-aware warranty rules. Compliance is built in — it's not the reason you buy BrandedMark, but you get it anyway.
          </p>
        </div>
      </div>
    </div>
  );
};
